import { render, staticRenderFns } from "./CommonGrid.vue?vue&type=template&id=507df964"
import script from "./CommonGrid.vue?vue&type=script&lang=js"
export * from "./CommonGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports